import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PitchButtons from '../items/PitchButtons';
import FormControl from '@mui/material/FormControl';
import CreatorsDialog from './CreatorsDialog';
import MuvikaService from './../../services/muvika';
import InputLabel from '@mui/material/InputLabel';
import songbookSessionStore from './../../stores/songbookSession';
import messageStore from '../../stores/message';
import { Views } from './../../enums/enums';
import Link from '@mui/material/Link';
import searchStore from '../../stores/search';
import navigationStore from '../../stores/navigation';

function EditSongbookPerformance(props) {

  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);

  const itemsOnPage = 25;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = searchStore((state) => state.search);
  const setOnlyArtist = searchStore((state) => state.setOnlyArtist);

  const [currentPitch, setCurrentPitch] = useState(props.performance.pitch);

  const [creators, setCreators] = useState(null);

  const getCreators = () => { 
    if (props.perofrmance) {
      if (props.performance.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.performance.track.track_id)
          .then(function (res) {
            //console.log(res);
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => { 
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => { 
    setIsCreatorsDialogOpen(false);
  };

  const handlePitchChange = (event, newPitch) => {
setCurrentPitch(newPitch);
  };

  const renderChangeTrackButton = () => { 
    if (props.onPerformanceToBeChanged) {
      return <Button variant="text" className="muvika-change-song-button" onClick={() => { 
        props.onPerformanceToBeChanged();
        props.onClose();
      }}>{TR.cm_change_song}</Button>;
    }
  };

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else {
        props.onEdit(currentPitch);
      }
    }
  };

  const handleSearchArtist = () => {
      props.onClose();
      setOnlyArtist();
      setSearchQuery(props.performance.track.artist);
      search(sessionToken, itemsOnPage);
      goToView(Views.Search);
    };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.performance.track} />
      <DialogContent>
        <img className="muvika-cover-image" src={props.performance.track.url_cover_image} alt="" />
        <h4 className="muvika-track-title">
        <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.performance.track.artist}
          </Link> - {props.performance.track.title} ({props.performance.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
          {renderChangeTrackButton()}
        </h4>
        <Stack spacing={5}>
          <p>{TR.cm_singer}: {props.performance.profile.name}</p>
          <Paper className="muvika-pitch-buttons">
            <p className="muvika-pitch-title">
              {TR.cm_key_pitch}
            </p>
            <PitchButtons value={currentPitch} onPitchChange={handlePitchChange} />
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onEdit(currentPitch)}>{TR.cm_save}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default EditSongbookPerformance;